import { selectedCalendarsStore } from '../store/store';
import { getUserMailboxInfo } from 'owa-client-ids';
import { dedupeArrayValues } from 'owa-selected-calendars-utils';
import { userConfigurationSet } from 'owa-session-store';
import { mutator } from 'satcheljs';

mutator(userConfigurationSet, actionMessage => {
    const { userConfiguration, primarySmtpAddress } = actionMessage;
    selectedCalendarsStore().selectedCalendars.set(
        primarySmtpAddress ? primarySmtpAddress : getUserMailboxInfo().primarySmtpAddress,
        dedupeArrayValues(userConfiguration.ViewStateConfiguration.SelectedCalendarsDesktop)
    );
});
